import { Address } from 'cluster';
import { APIClient } from 'service/apicataleg/api/APIHttpClient';
import {
  AddressDTO,
  CartCap,
  ClientDTO,
  LoginRequest,
  MarcaDTO,
  UserRole,
} from 'service/apicataleg/types/ApiCatalegTypes';

type LoginResponse = {
  role: 'moderador' | 'representant';
  accessToken: string;
  refreshToken: string;
  type: 'Bearer';
  username: string;
  name: string;
  empre: number;
  codi: number;
};

export type ClientPayload = {
  adreces: Array<AddressDTO>;
  cistelles: Array<CartCap>;
  client: ClientDTO;
  marques: Array<MarcaDTO>;
};

type LoginClientResponse = {
  role: 'client';
  accessToken: string;
  refreshToken: string;
  type: 'Bearer';
  username: string;
  name: string;
  empre: number;
  codi: number;
  payload: ClientPayload;
};

export type LoginSuccessPayload = LoginResponse | LoginClientResponse;

type LoginResult = {
  success: boolean;
  response: LoginSuccessPayload | null;
  message?: string;
};

const AuthSerivce = {
  async login({ username, password }: LoginRequest): Promise<LoginResult> {
    return APIClient.post<LoginSuccessPayload>('/auth/signin', { username, password })
      .then((response) => {
        const { data } = response;
        return { success: true, response: data };
      })
      .catch((error) => {
        return { success: false, response: null, message: error.message };
      });
  },
};

export default AuthSerivce;
